var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTf2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4818 0.310636C16.804 1.41442 20 5.33389 20 9.99997C20 10.1064 19.9978 10.2124 19.9944 10.3181L13.2683 9.36131C13.0714 8.3478 12.415 7.49911 11.5245 7.03953L12.4818 0.310636ZM7.03958 8.47526C7.49911 7.58485 8.34786 6.92851 9.36132 6.73158L10.3181 0.00553714C10.2123 0.00223726 10.1065 0 9.99994 0C5.33391 0 1.41444 3.19585 0.310584 7.51802L7.03958 8.47526ZM8.47527 12.9603C7.5849 12.5007 6.9285 11.652 6.73162 10.6385L0.00553711 9.68184C0.00223718 9.78761 0 9.89348 0 9.99997C0 14.6659 3.19589 18.5854 7.51807 19.6891L8.47527 12.9603ZM12.9604 11.5246C12.5008 12.415 11.6521 13.0713 10.6386 13.2684L9.68181 19.9943C9.78752 19.9978 9.89351 20 10 20C14.666 20 18.5856 16.8039 19.6894 12.4819L12.9604 11.5246Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTf2);
export default __webpack_public_path__ + "static/media/tf2.c229e413ccb7d14490a9a1508ca24b4b.svg";
export { ForwardRef as ReactComponent };